module.exports = __webpack_public_path__ + "static/img/rectangle07.b3912d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/rectangle/rectangle07.jpg
// module id = L8Lg
// module chunks = 0